import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { AbstractControl, ValidationErrors, FormControl } from '@angular/forms'
import { ResourceService } from 'app/shared/resources/resource.service'

import { IFlowOrAmendment, FlowOrAmendment, ensureFlowOrAmendment, toParamsObj } from 'app/shared/utils'
import { FormGroup } from '@angular/forms';
import { IUserLoyaltyCardWire, IValidationResult } from 'app/passengers/passengers.interfaces';
import { FormBuilderTyped } from 'app/shared/form-builder-typed';
import { ILoyaltyCard, LoyaltyActionEnum } from 'app/shared/models/reservation.interfaces';
import { LoyaltyNectarService } from 'app/passengers/loyalty/nectar/nectar.service';
import { StatelessHttpService } from 'app/shared/stateless-http.service';

@Component({
    selector: 'sbw-loyalty-nectar',
    templateUrl: './nectar.component.html',
    styleUrls: ['./nectar.component.css']
})
export class LoyaltyNectarComponent implements OnInit, IFlowOrAmendment {
    @Input() mode: FlowOrAmendment
    @Input() model: IInputLoyaltyCard
    @Output() pointsToEarn = new EventEmitter<number>()

    cardNumberExistInUserProfile = false
    couldNotRemoveCardFromProfile = false

    form: FormGroup

    get cardNumber() {
        return this.formCardNumber.value
    }
    set cardNumber(value) {
        this.formCardNumber.setValue(value)
    }

    get formCardNumber() {
        return this.form.get('cardNumber')
    }

    get formLoyaltyAction() {
        return this.form.get('loyaltyAction')
    }

    mask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]

    constructor(
        private statelessHttpService: StatelessHttpService,
        private resourceService: ResourceService,
        private loyaltyNectarService: LoyaltyNectarService,
        private fb: FormBuilderTyped
    ) { }


    ngOnInit() {
        ensureFlowOrAmendment(this.mode)
        if (this.mode === 'Flow') {
            this.useFlow()
        } else if (this.mode === 'Amendment') {
            this.useAmendment()
        }
    }

    useFlow() {
        const userLoyaltyCard = this.model.userLoyaltyCards.find(c => c.provider === this.model.provider)
        const provider = this.model.provider
        const cardNumberLast4Digits = userLoyaltyCard != null ? userLoyaltyCard.cardNumberLast4Digits : null
        const points = userLoyaltyCard != null ? userLoyaltyCard.points : 0
        let value = userLoyaltyCard != null ? userLoyaltyCard.cardNumber : null

        if (value != null) {
            this.cardNumberExistInUserProfile = true
        }

        if (cardNumberLast4Digits != null && cardNumberLast4Digits.length === 4) {
            value = 'XXXXXXX' + cardNumberLast4Digits
            this.cardNumberExistInUserProfile = true
        }

        this.form = this.fb.group<ILoyaltyCard>({
            provider: this.fb.control(provider),
            cardNumber: new FormControl({ value, disabled: this.cardNumberExistInUserProfile }, {
                updateOn: 'change',
                validators: [this.factoryValidateCardSyncValidator(11)],
                asyncValidators: this.factoryValidateCardAsyncValidator()
            }),
            points: this.fb.control(points),
            loyaltyAction: this.fb.control(this.cardNumberExistInUserProfile ? LoyaltyActionEnum.existingCard : LoyaltyActionEnum.noCard)
        })

        this.formCardNumber.statusChanges.subscribe(x => this.formLoyaltyAction.setValue(x === 'VALID' && this.cardNumber ? LoyaltyActionEnum.newCard : LoyaltyActionEnum.noCard))
        this.model.form.addControl('loyaltyCards', this.form)
    }
    useAmendment() {
        throw new Error('Method not implemented.');
    }

    removeCardFromUserProfile(): void {
        this.loyaltyNectarService.removeCardFromUserProfile(this.model.provider).subscribe(result => {
            if (result.success) {
                this.cardNumberExistInUserProfile = false
                this.couldNotRemoveCardFromProfile = false
                this.cardNumber = null
                this.formLoyaltyAction.setValue(LoyaltyActionEnum.noCard)
                this.formCardNumber.enable()
                this.pointsToEarn.emit(null)
            } else {
                this.couldNotRemoveCardFromProfile = true
            }
        })
    }

    private unMaskControl(c: AbstractControl): string {
        return c.value && c.value.replace(/_/g, '')
    }

    factoryValidateCardSyncValidator(length = 11): (c: AbstractControl) => ValidationErrors | null {
        return (c: AbstractControl): ValidationErrors | null => {
            const unMaskedValue = this.unMaskControl(c)
            return !unMaskedValue || unMaskedValue.length === length ? null : { length: true }
        }
    }

    factoryValidateCardAsyncValidator(): (c: AbstractControl) => Promise<ValidationErrors | null> {
        return (c: AbstractControl): Promise<ValidationErrors | null> => {
            return new Promise((res, rej) => {
                const unMaskedValue = this.unMaskControl(c)
                if (!unMaskedValue) { return res(null) }
                const url = `loyalty/${this.model.provider}/${this.model.preCardNumber}${unMaskedValue}/validate`
                let params = {
                    'salesOwner': this.resourceService.getSalesOwner(),
                    'totalPrice': `${this.model.totalPrice}`,
                    'hasAccommodation': this.model.hasAccommodation
                }
                this.statelessHttpService.get<IValidationResult>(true, url, { params: toParamsObj(params) }).subscribe(x => {
                    res(x.valid ? null : { checkCardNumber: true })
                    if (x.valid) {
                        this.form.get('points').setValue(x.points)
                    }
                    this.pointsToEarn.emit(x.points)
                })
            })
        }
    }
}

export interface IInputLoyaltyCard {
    form: FormGroup
    provider: number,
    userLoyaltyCards: IUserLoyaltyCardWire[]
    preCardNumber: string
    totalPrice: number
    hasAccommodation: boolean
}
